import angular from "angular";
import { InputEnumOption, OpenAPIV3 } from "@salaxy/core";
import { JsonSchemaService, UiHelpers } from "../../services";

/**
 * Controller for schema editing user interfaces. Current implementation is OpenAPI V3 schema editing.
 */
export class SxySchemaEditorController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["JsonSchemaService", "UiHelpers"];

  /** Schema object that is being edited. */
  public model: OpenAPIV3.SchemaObject;

  public types: (InputEnumOption & {
      formats: InputEnumOption[],
    })[];

  constructor(
    private jsonSchemaService: JsonSchemaService,
    private uiHelpers: UiHelpers,
  ) {
    // Dependency injection
  }

  /** Initializes the controller */
  public $onInit() {
    this.types = [];
    const inputs = this.jsonSchemaService.getRegisteredInputs();
    // TODO: Move to dictionary
    const labels = { "string": "Teksti", "number": "Numero", "array": "Lista", "boolean": "On/off (boolean)", "integer": "Kokonaisluku", "object": "Muu..." };
    Object.keys(inputs).forEach((key) => {
      this.types.push({
        text: labels[key],
        value: key,
        formats: Object.keys(inputs[key]).map((x) => ({
          text: x == "default" ? "Oletus" : x, // TODO: Translate
          value: x == "default" ? "" : x,
        }))});
    });
  }

  /** Adds a new property to the current schema */
  public addProperty() {
    // TODO: Add this to UI Helpers (as dialog) and search for prompt().
    const name = window.prompt("Mikä on lisättävän tietueen tekninen nimi (a-z, 0-1, ei välejä eikä erikoismerkkejä)?");
    // TODO: Add property name validation / fix.
    this.model[name] = {};
  }

  /** Deletes a property from the schema. */
  public deleteProperty(key) {
    delete this.model[key];
  }

  /** Gets the formats for given type */
  public getFormats(type: string) {
    return this.types.find((x) => x.value == type).formats;
  }
}